export default __webpack_public_path__ + "slices/main/assets/public/media/company-values@2x.643ec94b806c3efb6527c81ed8d5a8dc.png";